export type Language = "en" | "es";

export const translations = {
  // Landing Page
  landing: {
    heroTitle1: {
      en: "Instantly Adapt Images",
      es: "Adapta Imágenes al Instante",
    },
    heroTitle2: {
      en: "to Ads Formats",
      es: "a Formatos de Anuncios",
    },
    heroDescription: {
      en: "Transform your visuals between Square, Portrait, and Horizontal formats with AI precision.",
      es: "Transforma tus visuales entre formatos Cuadrado, Vertical y Horizontal con precisión de IA.",
    },
    heroHighlight: {
      en: "Fast. Affordable. Perfect every time.",
      es: "Rápido. Asequible. Perfecto siempre.",
    },
    ctaButton: {
      en: "Try Free — 3 Credits",
      es: "Prueba Gratis — 3 Créditos",
    },
    noCreditCard: {
      en: "No credit card required",
      es: "No se requiere tarjeta de crédito",
    },
    signIn: {
      en: "Sign In",
      es: "Iniciar Sesión",
    },
    allRightsReserved: {
      en: "All rights reserved.",
      es: "Todos los derechos reservados.",
    },
    faqTitle: {
      en: "Frequently Asked Questions",
      es: "Preguntas Frecuentes",
    },
  },

  // FAQ Content
  faq: {
    q1: {
      en: "How does Scalemage work?",
      es: "¿Cómo funciona Scalemage?",
    },
    a1: {
      en: "Upload any image, select your target formats (Square, Portrait, Horizontal), and our AI instantly adapts your image to each format while preserving quality and composition.",
      es: "Sube cualquier imagen, selecciona los formatos deseados (Cuadrado, Vertical, Horizontal), y nuestra IA adapta tu imagen al instante a cada formato preservando la calidad y composición.",
    },
    q2: {
      en: "What formats can I convert to?",
      es: "¿A qué formatos puedo convertir?",
    },
    a2: {
      en: "We support three formats: Square (1080x1080) for Instagram posts, Portrait (1080x1920) for Stories/Reels/TikTok, and Horizontal (1920x1080) for YouTube/LinkedIn.",
      es: "Soportamos tres formatos: Cuadrado (1080x1080) para posts de Instagram, Vertical (1080x1920) para Stories/Reels/TikTok, y Horizontal (1920x1080) para YouTube/LinkedIn.",
    },
    q3: {
      en: "How much does it cost?",
      es: "¿Cuánto cuesta?",
    },
    a3: {
      en: "Each image adaptation costs 1 credit. New users get 3 free credits. You can purchase 10 credits for $3 anytime.",
      es: "Cada adaptación de imagen cuesta 1 crédito. Los nuevos usuarios obtienen 3 créditos gratis. Puedes comprar 10 créditos por $3 en cualquier momento.",
    },
    q4: {
      en: "Can I make creative changes?",
      es: "¿Puedo hacer cambios creativos?",
    },
    a4: {
      en: "Yes! Use the Creative Context field to request specific changes like background modifications, lighting adjustments, or other transformations. You can get amazing results with Creative Context, but dont forget to call your designer for better results.",
      es: "¡Sí! Usa el campo de Contexto Creativo para solicitar cambios específicos como modificaciones de fondo, ajustes de iluminación u otras transformaciones.",
    },
    q5: {
      en: "What image formats are supported?",
      es: "¿Qué formatos de imagen se soportan?",
    },
    a5: {
      en: "You can upload JPG, PNG, and WEBP images.",
      es: "Puedes subir imágenes en JPG, PNG y WEBP.",
    },
  },

  // Auth Page
  auth: {
    welcomeBack: {
      en: "Welcome back! Sign in to continue.",
      es: "¡Bienvenido! Inicia sesión para continuar.",
    },
    createAccount: {
      en: "Create an account to get 3 free credits.",
      es: "Crea una cuenta y obtén 3 créditos gratis.",
    },
    email: {
      en: "Email",
      es: "Correo electrónico",
    },
    password: {
      en: "Password",
      es: "Contraseña",
    },
    signInButton: {
      en: "Sign In",
      es: "Iniciar Sesión",
    },
    createAccountButton: {
      en: "Create Account",
      es: "Crear Cuenta",
    },
    noAccount: {
      en: "Don't have an account? Sign up",
      es: "¿No tienes cuenta? Regístrate",
    },
    hasAccount: {
      en: "Already have an account? Sign in",
      es: "¿Ya tienes cuenta? Inicia sesión",
    },
    welcomeToast: {
      en: "Welcome back!",
      es: "¡Bienvenido de nuevo!",
    },
    accountCreated: {
      en: "Account created!",
      es: "¡Cuenta creada!",
    },
    freeCredits: {
      en: "You now have 3 free credits to get started.",
      es: "Ahora tienes 3 créditos gratis para comenzar.",
    },
    invalidCredentials: {
      en: "Invalid email or password",
      es: "Correo o contraseña inválidos",
    },
    unableToCreate: {
      en: "Unable to create account. Please try signing in instead.",
      es: "No se pudo crear la cuenta. Intenta iniciar sesión.",
    },
    tooManyAttempts: {
      en: "Too many attempts. Please try again later.",
      es: "Demasiados intentos. Intenta más tarde.",
    },
    genericError: {
      en: "An error occurred. Please try again.",
      es: "Ocurrió un error. Intenta de nuevo.",
    },
    validEmail: {
      en: "Please enter a valid email address",
      es: "Por favor ingresa un correo válido",
    },
    passwordLength: {
      en: "Password must be at least 6 characters",
      es: "La contraseña debe tener al menos 6 caracteres",
    },
    checkYourEmail: {
      en: "Check your email",
      es: "Revisa tu correo",
    },
    confirmToGetCredits: {
      en: "We sent you a confirmation link. Confirm your email to receive your 3 free credits and start using Scalemage.",
      es: "Te enviamos un enlace de confirmación. Confirma tu correo para recibir tus 3 créditos gratis y comenzar a usar Scalemage.",
    },
    resendConfirmation: {
      en: "Resend confirmation email",
      es: "Reenviar correo de confirmación",
    },
    emailResent: {
      en: "Confirmation email sent!",
      es: "¡Correo de confirmación enviado!",
    },
    disposableEmailError: {
      en: "Please use a valid email address. Temporary emails are not allowed.",
      es: "Por favor usa una dirección de correo válida. No se permiten correos temporales.",
    },
    emailNotConfirmed: {
      en: "Please confirm your email before signing in.",
      es: "Por favor confirma tu correo antes de iniciar sesión.",
    },
  },

  // Studio Page
  studio: {
    sourceImage: {
      en: "Source Image",
      es: "Imagen de Origen",
    },
    output: {
      en: "Output",
      es: "Resultado",
    },
    generating: {
      en: "Generating...",
      es: "Generando...",
    },
    generate: {
      en: "Generate",
      es: "Generar",
    },
    credit: {
      en: "credit",
      es: "crédito",
    },
    credits: {
      en: "credits",
      es: "créditos",
    },
    selectImageAndFormat: {
      en: "Please select an image and at least one format",
      es: "Por favor selecciona una imagen y al menos un formato",
    },
    errorPaymentLink: {
      en: "Error creating payment link",
      es: "Error al crear enlace de pago",
    },
    tryAgainLater: {
      en: "Please try again later.",
      es: "Por favor intenta más tarde.",
    },
    requestTimedOut: {
      en: "Request timed out. Please try again.",
      es: "La solicitud expiró. Intenta de nuevo.",
    },
    errorGeneratingFormat: {
      en: "Error generating format",
      es: "Error al generar formato",
    },
    errorGeneratingImages: {
      en: "Error generating images",
      es: "Error al generar imágenes",
    },
    image: {
      en: "image",
      es: "imagen",
    },
    images: {
      en: "images",
      es: "imágenes",
    },
  },

  // Header
  header: {
    credits: {
      en: "Credits",
      es: "Créditos",
    },
    upgrade: {
      en: "ADD CREDITS",
      es: "AGREGAR CREDITOS",
    },
    loading: {
      en: "Loading...",
      es: "Cargando...",
    },
    reportIssue: {
      en: "Report an issue",
      es: "Reportar un problema",
    },
    signOut: {
      en: "Sign out",
      es: "Cerrar sesión",
    },
    menu: {
      en: "Menu",
      es: "Menú",
    },
    adminDashboard: {
      en: "Admin Dashboard",
      es: "Panel de Admin",
    },
  },

  // Format Selector
  formats: {
    outputFormats: {
      en: "Output Formats",
      es: "Formatos de Salida",
    },
    creditEach: {
      en: "(1 credit each)",
      es: "(1 crédito cada uno)",
    },
    square: {
      en: "Square",
      es: "Cuadrado",
    },
    portrait: {
      en: "Portrait",
      es: "Vertical",
    },
    horizontal: {
      en: "Horizontal",
      es: "Horizontal",
    },
  },

  // Image Upload
  imageUpload: {
    dragAndDrop: {
      en: "Drag and drop your image here",
      es: "Arrastra y suelta tu imagen aquí",
    },
    clickToBrowse: {
      en: "or click to browse (JPG, PNG, WEBP)",
      es: "o haz clic para seleccionar (JPG, PNG, WEBP)",
    },
    sourceImage: {
      en: "Source image",
      es: "Imagen de origen",
    },
  },

  // Creative Context
  creativeContext: {
    label: {
      en: "Creative Context",
      es: "Contexto Creativo",
    },
    optional: {
      en: "(optional)",
      es: "(opcional)",
    },
    placeholder: {
      en: "Describe any specific changes you'd like... (e.g., change background, modify lighting, age transformation)",
      es: "Describe los cambios específicos que deseas... (ej., cambiar fondo, modificar iluminación, transformación de edad)",
    },
    prompts: {
      older: {
        en: "Make the person look 10 years older",
        es: "Hacer que la persona se vea 10 años mayor",
      },
      beach: {
        en: "Change the background to a beach sunset",
        es: "Cambiar el fondo a un atardecer en la playa",
      },
      lighting: {
        en: "Add dramatic lighting and shadows",
        es: "Añadir iluminación y sombras dramáticas",
      },
      logo: {
        en: "Keep the logo centered when extending",
        es: "Mantener el logo centrado al extender",
      },
    },
  },

  // Output Panel
  outputPanel: {
    output: {
      en: "Output",
      es: "Resultado",
    },
    generatedImagesWillAppear: {
      en: "Generated images will appear here",
      es: "Las imágenes generadas aparecerán aquí",
    },
    generating: {
      en: "Generating",
      es: "Generando",
    },
    download: {
      en: "Download",
      es: "Descargar",
    },
    generated: {
      en: "Generated",
      es: "Generado",
    },
  },

  // No Credits Modal
  noCredits: {
    title: {
      en: "You're out of credits!",
      es: "¡Te quedaste sin créditos!",
    },
    description: {
      en: "Get 10 credits for just $3 and continue creating amazing image adaptations.",
      es: "Obtén 10 créditos por solo $3 y continúa creando adaptaciones de imagen increíbles.",
    },
    getCredits: {
      en: "Get 10 Credits for $3",
      es: "Obtener 10 Créditos por $3",
    },
    maybeLater: {
      en: "Maybe later",
      es: "Quizás más tarde",
    },
  },

  // Payment History
  paymentHistory: {
    title: {
      en: "Payment History",
      es: "Historial de Pagos",
    },
    noPayments: {
      en: "No payments yet",
      es: "Sin pagos aún",
    },
    credits: {
      en: "Credits",
      es: "Créditos",
    },
    completed: {
      en: "completed",
      es: "completado",
    },
  },

  // Not Found
  notFound: {
    title: {
      en: "404",
      es: "404",
    },
    message: {
      en: "Oops! Page not found",
      es: "¡Ups! Página no encontrada",
    },
    returnHome: {
      en: "Return to Home",
      es: "Volver al Inicio",
    },
  },
} as const;

export type TranslationKey = keyof typeof translations;
